import { combineReducers } from 'redux'

import groupSettingsAssignReducer from './Assign/reducer'
import groupSettingsReducer from './Table/reducer'
import groupSettingsWizardReducer from './Wizard/reducer'

export default function () {
  const initialState = combineReducers({
    self: groupSettingsReducer(),
    wizard: groupSettingsWizardReducer(),
    assign: groupSettingsAssignReducer(),
  })
  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
